module.exports = __webpack_public_path__ + "static/media/entregapapasmini.4859b690.webp";